import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Box from '@bit/knotchinc.web-react-components.box';
import Text from '@bit/knotchinc.web-react-components.text';
import ClickOutside from '@bit/knotchinc.web-react-components.click-outside';
import {
  InputLabel,
  DropdownContainer,
  DropdownArrow,
  DropdownOptions,
  DropdownScrollContainer,
  StyledDropdownOption,
  Tick,
} from './styled';

const DropdownOption = ({ selected, text, onClick }) => <StyledDropdownOption onClick={() => onClick()}>
  <Tick selected={selected} />
  <Text color="white" pl="10px" fontSize="12px" display="inline-block">{text}</Text>
</StyledDropdownOption>;

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  updateValue(value) {
    this.setState({
      open: false,
    });
    this.props.onClick(value);
  }

  render() {
    const { label, value, options, defaultOption } = this.props;
    let displayValue = defaultOption || 'Select...';
    if (value) {
      displayValue = options.filter(option => option.value === value)[0].text;
    }

    return (<React.Fragment>
      <InputLabel>{label}</InputLabel>
      <ClickOutside close={() => this.setState({ open: false })}>
        <DropdownContainer onClick={() => this.setState({ open: !this.state.open })}>
          <Text color="white" fontSize="12px" display="inline-block">{displayValue}</Text>
          <DropdownArrow />
        </DropdownContainer>
        { this.state.open && <Box width="100%" position="relative">
          <DropdownOptions>
            <PerfectScrollbar>
              <DropdownScrollContainer>
                {defaultOption && <DropdownOption text={defaultOption} key={defaultOption} selected={!value} onClick={() => this.updateValue('')} />}
                {options.map(option =>
                  <DropdownOption
                    text={option.text}
                    key={option.value}
                    selected={value && value === option.value}
                    onClick={() => this.updateValue(option.value)}
                  />)}
              </DropdownScrollContainer>
            </PerfectScrollbar>
          </DropdownOptions>
        </Box>}
      </ClickOutside>
    </React.Fragment>);
  }
}


export default Dropdown;
